import React from "react";

const Advanced = () => {
  return (
    <React.Fragment>
      <h1>ACLs advanced</h1>
    </React.Fragment>
  );
};

export default Advanced;
